import React, { Component } from "react"
import URL from "url-parse"

import SpinnerImage from "../../common/SpinnerImage"

// The live site can't be embedded (most publishers send X-Frame-Options /
// CSP frame-ancestors), and the browser can't fetch their HTML cross-origin
// either. So we show an instant, zero-network affordance (favicon + domain +
// path) with a progress skeleton while the ~30s scrape runs. Once it lands the
// item's details show beside it, so the card is replaced by AddFeedSavedNotice
// rather than repeating them.

// Favicon served straight from the site's origin, falling back to a generic
// glyph if the request fails.
class Favicon extends Component {
    state = { failed: false }

    render() {
        const { origin } = this.props
        if (this.state.failed || !origin) {
            return <span className="icon icon-source url-preview-favicon" />
        }
        return (
            <img
                className="url-preview-favicon"
                src={`${origin}/favicon.ico`}
                alt=""
                onError={() => this.setState({ failed: true })}
            />
        )
    }
}

const UrlPreviewCard = ({ previewURL, hasError }) => {
    const parsed = new URL(previewURL || "")
    const path = parsed.pathname && parsed.pathname !== "/" ? parsed.pathname : ""

    return (
        <div className="url-preview-card">
            <div className="url-preview-head">
                <Favicon origin={parsed.origin} />
                <div className="url-preview-locator">
                    <span className="url-preview-host">{parsed.host}</span>
                    {path && <span className="url-preview-path">{path}</span>}
                </div>
            </div>

            {hasError ? (
                <div className="url-preview-error">
                    <p>Couldn't analyse this URL.</p>
                    <a
                        href={previewURL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Open original
                    </a>
                </div>
            ) : (
                <div className="url-preview-loading">
                    <div className="url-preview-skeleton url-preview-skeleton-image" />
                    <div className="url-preview-skeleton url-preview-skeleton-line" />
                    <div className="url-preview-skeleton url-preview-skeleton-line short" />
                    <p className="url-preview-status">
                        <SpinnerImage />
                        &nbsp;Analysing article… (can take up to 30s)
                    </p>
                </div>
            )}
        </div>
    )
}

export default UrlPreviewCard
